module.exports = __webpack_public_path__ + "img/Successful.18b6f9fe.png";